import { render, staticRenderFns } from "./artificial-intelligence.vue?vue&type=template&id=2ae77106&scoped=true"
import script from "./artificial-intelligence.vue?vue&type=script&lang=js"
export * from "./artificial-intelligence.vue?vue&type=script&lang=js"
import style0 from "./artificial-intelligence.vue?vue&type=style&index=0&id=2ae77106&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae77106",
  null
  
)

export default component.exports